// import {useAuthorization} from '@sttedra_ui/framework';
import { loginInternal } from "@/api/auth/auth.api.js";
import {
  setCustomAccessToken,
  isInMitmaNetwork,
  getMsalToken,
  clearAuthData,
  checkTokenExpired,
  setImpersonationToken,
  impersonatedUserIsAdmin,
} from "@/composables/_commons/auth.js";

function setLastRoute(to) {
  localStorage.setItem("lastRoute", to);
}

export default [
  async function checkUserAuth(to, from, next) {
    // const {modelRef: authorizationModelRef} = useAuthorization();
    const isInMitmaNetworkResult = await isInMitmaNetwork();
    const msalToken = await getMsalToken();

    let accessToken = localStorage.getItem("accessToken");
    const manualLogout = localStorage.getItem("manualLogout");
    let lastRoute = localStorage.getItem("lastRoute");
    const tokenExpired = localStorage.getItem("tokenExpired");
    const forceLogin = localStorage.getItem("forceLogin");
    const impersonationToken = localStorage.getItem("impersonationToken");
    const maximumExpirationTime = localStorage.getItem("maximumExpirationTime");
    let internalLogin = localStorage.getItem("internalLogin");

    if (maximumExpirationTime === "true") {
      setLastRoute(to.fullPath);
      localStorage.removeItem("maximumExpirationTime");
    }

    if (msalToken) {
      internalLogin = null;
      localStorage.removeItem("internalLogin");
    }

    if (
      to.name !== "Login" &&
      !tokenExpired &&
      !forceLogin &&
      !maximumExpirationTime
    ) {
      // Si el usuario ya está autenticado y trata de acceder a Login, redirigir a Reports
      // Si hay logout manual, guardar la ruta a la que intenta acceder
      setLastRoute(to.fullPath);
    }

    if (accessToken) {
      await setCustomAccessToken(accessToken, { checkToken: false });

      if (to.name == "Login") {
        lastRoute = null;
      }
    }

    // Si la ruta es PublicReport, permitir acceso
    if (to.name === "PublicReport") {
      // Si hay token de acceso, comprobar si ha expirado
      if (accessToken) {
        const expired = await checkTokenExpired();

        if (expired) {
          localStorage.setItem("tokenExpired", "true");

          await clearAuthData();
          next({ name: "Login" });
          return;
        }
      }

      next();
      return;
    }

    // Si hay token de MSAL pero no token interno, intentar login interno
    if (msalToken && !accessToken) {
      const response = await loginInternal(msalToken);

      if (response?.status == 200 && response?.data?.access_token) {
        accessToken = response.data.access_token;
        await setCustomAccessToken(accessToken);
      } else {
        await clearAuthData();
      }
    }

    // Si no hay token de acceso
    if (!accessToken) {
      // Si el usuario está en la red MITMA (y no ha hecho logout manual), forzar login
      if (isInMitmaNetworkResult && !manualLogout && !internalLogin) {
        localStorage.setItem("forceLogin", "true");
      }

      if (to.name === "Login") {
        next();
        return;
      } else {
        next({ name: "Login" });
        return;
      }
    }

    // Si hay token de acceso, comprobar si ha expirado
    if (accessToken) {
      const expired = await checkTokenExpired();

      if (expired) {
        localStorage.setItem("tokenExpired", "true");

        if (from.path == to.path && !maximumExpirationTime) {
          setLastRoute(to.fullPath);
        }

        await clearAuthData();
        next({ name: "Login" });
        return;
      }
    }

    // Si el usuario ya tiene token de acceso, eliminar flag de logout manual
    localStorage.removeItem("manualLogout");

    // Si hay token de impersonación, establecerlo
    if (impersonationToken) {
      setImpersonationToken(JSON.parse(impersonationToken));
    }

    // Si venimos de una expiración de token, redirigir a la última ruta
    if (lastRoute && (tokenExpired === "true" || forceLogin === "true")) {
      localStorage.removeItem("tokenExpired");
      localStorage.removeItem("forceLogin");
      next({ path: lastRoute });
      return;
    }

    // Si el usuario ya está autenticado y trata de acceder a Login, redirigir a Reports
    if (to.name === "Login") {
      if (!lastRoute && !maximumExpirationTime) {
        setLastRoute("/informes");
      }

      next(lastRoute || "/informes");
      return;
    }

    // Si el usuario intenta acceder a "/admin/[ALGO]" sin ser Admin, redirigir a /informes
    const impersonatedUserIsAdminResult = impersonatedUserIsAdmin();

    if (
      to.path.startsWith("/admin/") &&
      impersonatedUserIsAdminResult === false
    ) {
      next({ name: "Public reports" });
      return;
    }

    // Continuar con la navegación
    next();
  },
];
